/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

(() => {
  if (window.sonicSavvyAmazonTracking) return;
  window.sonicSavvyAmazonTracking = true;
  function trackAmazonClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest && event.target.closest('a[href], .myy-click');
    if (!link) return;
    let url;
    try { url = new URL(link.href || 'https://www.amazon.ca/?tag=sonicsavvysto-20'); } catch (_) { return; }
    if (!/(^|\.)amazon\.(ca|com|co\.uk|de|fr|it|es|com\.au|co\.jp|in)$/.test(url.hostname) && url.hostname !== 'amzn.to') return;
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    const destination = new URL(url.origin + url.pathname);
    if (url.searchParams.has('tag')) destination.searchParams.set('tag', url.searchParams.get('tag'));
    try {
      const result = analytics.publish('sonicsavvy:amazon_outbound_click', {
        link_url: destination.href,
        link_domain: url.hostname,
        link_text: link.textContent.trim().slice(0, 100),
        page_location: location.origin + location.pathname
      });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {}
  }
  document.addEventListener('click', trackAmazonClick, true);
  document.addEventListener('auxclick', trackAmazonClick, true);
})();

